/**
 * Stringå·¥å·ç±»
 */
export class StringUtil {
  /**
   * ææ¬æ¯è¾
   * @param compareType "startsWith", "contains", "endsWidth", "equals", "notEquals" and "in"
   */
  static compare(source: string, target: string, compareType: string): boolean {
    if (target === null) {
      return true;
    } else if (source === null) {
      return false;
    }
    switch (compareType) {
      case 'startsWith':
        return source.startsWith(target.trim());
      case 'endsWidth':
        return source.endsWith(target.trim());
      case 'equals':
        return source === target.trim();
      case 'notEquals':
        return source !== target.trim();
      case 'in':
        return (',' + target + ',').indexOf(',' + source + ',') >= 0;
      case 'contains':
      default:
        return source.indexOf(target.trim()) >= 0;
    }
  }

  /**
   * LPAD
   */
  static lpad(str: string, len: number, char: string): string {
    if (str.length < len) {
      return Array(len - str.length + 1).join(char) + str;
    }
    return str;
  }

  /**
   * å­ç¬¦å¸å°å¼è½¬å¸å°
   */
  static toBoolean(val: any): boolean {
    if (val != null) {
      if (typeof val === 'boolean') {
        return val;
      } else if (typeof val === 'string') {
        return val.toLowerCase() === 'true' || val.toLowerCase() === 'on';
      }
    }
    return false;
  }
}
